// Textos de vencimiento de «Mis tareas». Los grupos los calcula el servidor; aqui solo
// se dice la fecha en palabras. Se compara por DIA (sin hora) para que un desfase de
// zona horaria no convierta «hoy» en «ayer».

const MS_DIA = 86400000;
const SEMANA = ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"];
const MES = ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"];

export const aIso = d =>
  `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;

const aDia = iso => {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(iso || ""));
  return m ? Date.UTC(+m[1], +m[2] - 1, +m[3]) : null;
};

// -> { texto, tono } con tono "venc" | "hoy" | "normal" | "sin".
export function textoVencimiento(fecha, hoy = new Date()) {
  const f = aDia(fecha);
  if (f === null) return { texto: "Sin fecha", tono: "sin" };
  const h = aDia(aIso(hoy));
  const dif = Math.round((f - h) / MS_DIA);
  if (dif < 0) return { texto: dif === -1 ? "Vencida ayer" : `Vencida hace ${-dif} días`, tono: "venc" };
  if (dif === 0) return { texto: "Hoy", tono: "hoy" };
  if (dif === 1) return { texto: "Mañana", tono: "normal" };
  const d = new Date(f);
  const dia = SEMANA[d.getUTCDay()];
  return { texto: dif < 7 ? `${dia} ${d.getUTCDate()} ${MES[d.getUTCMonth()]}` : `${d.getUTCDate()} ${MES[d.getUTCMonth()]}`, tono: "normal" };
}

// Siguiente lunes (para «Aplazar al lunes»); si hoy es lunes, el de la semana siguiente.
export function proximoLunes(hoy = new Date()) {
  const d = new Date(hoy.getFullYear(), hoy.getMonth(), hoy.getDate());
  const dias = ((8 - d.getDay()) % 7) || 7;
  d.setDate(d.getDate() + dias);
  return aIso(d);
}

export function manana(hoy = new Date()) {
  const d = new Date(hoy.getFullYear(), hoy.getMonth(), hoy.getDate() + 1);
  return aIso(d);
}
